import React, { useEffect, useState } from "react";
import MainLayout from "../components/MainLayout";
import { mainTable } from "../css/Common";
import InputText from "../ReusableComponents/InputText";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import ReportGridPage from "../components/ReportGridPage";
import { ageGenderDonorSRHHeader } from "../components/HeaderAttribute";
import jsPDF from "jspdf";
import "jspdf-autotable";
import fpaiLogo from "../image/FPAILogo.jpg";
import MultiSelect from "../ReusableComponents/MultiSelect";
import * as XLSX from "sheetjs-style";
import { useUserCapability } from "../components/ConstantReducerProvider";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";

const ReportAgeGenderDonorSRH = () => {
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [branchName, setBranchName] = useState("");
  const [project, setProject] = useState("");
  const [bindProjectDD, setBindProjectDD] = useState([]);

  const [ageGenderFields, setAgeGenderFields] = useState({
    branchProject: "",
    sdp: "",
    area: "",
    serviceCategory: "",
    serviceSubCategory: "",
    servicesName: "",
  });
  const [ageGenderFieldsError, setAgeGenderFieldsError] = useState({
    sdpError: "",
    areaError: "",
    branchProjectError: "",

    serviceCategoryError: "",
    serviceSubCategoryError: "",
    servicesNameError: "",
  });

  const [showTable, setShowTable] = useState(false);

  const [getSDPDatas, setGetSDPDatas] = useState([]);
  const [getAreaDatas, setGetAreaDatas] = useState([]);
  const [bindArea, setBindAreaDD] = useState([]);
  const [bindSDP, setBindSDP] = useState([]);
  const [getServicesData, setGetServicesDatas] = useState([]);
  const [getServiceSubCDatas, setGetServiceSubCDatas] = useState([]);
  const [bindServicesName, setBindServicesName] = useState([]);
  const [bindServiceSubCategory, setBindServiceSubCategory] = useState([]);
  const [bindBranchProjectDD, setBindBranchProjectDD] = useState([]);
  const [bindAgeGenderDonorSRH, setBindAgeGenderDonorSRH] = useState([]);
  const [bindServiceCategory, setBindServiceCategory] = useState([]);

  const [branchProjectNamesList, setBranchProjectNamesList] = useState([]);
  const [sdpNamesList, setSDPNamesList] = useState([]);
  const [areaNamesList, setAreaNamesList] = useState([]);
  const [serviceCategoryNameList, setServiceCategoryNameList] = useState([]);
  const [serviceSubCategoryNameList, setServiceSubCategoryNameList] = useState(
    []
  );
  const [serviceNameList, setServiceNameList] = useState([]);

  useEffect(() => {
    if (
      userProfileDatas[0]?.MstOrganizationId == 2 ||
      userProfileDatas[0]?.MstOrganizationId == 3
    ) {
      setBranchName(userProfileDatas[0]?.LocationName_en);
      if (userProfileDatas[0]?.MstSDPId == null) {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: "",
        });
      } else {
        setAgeGenderFields({
          ...ageGenderFields,
          branchProject: [userProfileDatas[0]?.MstLocationId],
          sdp: [userProfileDatas[0]?.MstSDPId],
        });
      }
    }
    BranchProjectFetchData();
    serviceCategoryDD();
    getProjectDDValues();
  }, [userProfileDatas ? userProfileDatas : undefined]);
  const getProjectDDValues = async () => {
    // Month Dropdown binding
    const userProfileDatas = userProfileState.userProfile;
    const [profile] = userProfileDatas;
    const data = {
      mstOrganizationStructureId: profile.MstOrganizationId,
      mstBranchId: profile.MstLocationId,
      mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
      mstUserId: profile.MstUserId,
      mstRoleId: profile.MstRoleId,
      languageCode: "en",
    };

    const response = await BindPostAPI([data], "MasterDataAPI/BindProject");
    const getTnxProjectId =
      response.data.Table && response.data.Table.length > 0
        ? response.data.Table.map((item) => ({
          value: item.MstProjectId,
          label: item.ProjectName_en,
        }))
        : [];
    setBindProjectDD(getTnxProjectId);
  };
  const GoButton = async () => {
    const branchProjectValidate = ageGenderFields.branchProject
      ? ""
      : "Select Branch/Project";
    const sdpValidate = ageGenderFields.sdp ? "" : "Select SDP";

    const areaValidate = ageGenderFields.area ? "" : "Select Area";

    const serviceCategoryValidate = ageGenderFields.serviceCategory
      ? ""
      : "Select Service Category";
    const serviceSubCategoryValidate = ageGenderFields.serviceSubCategory
      ? ""
      : "Select Service Sub-Category";
    const servicesNameValidate = ageGenderFields.servicesName
      ? ""
      : "Select  Services";
    setAgeGenderFieldsError({
      ...ageGenderFieldsError,
      branchProjectError: branchProjectValidate,
      sdpError: sdpValidate,
      areaError: areaValidate,
      serviceCategoryError: serviceCategoryValidate,
      serviceSubCategoryError: serviceSubCategoryValidate,
      servicesNameError: servicesNameValidate,
    });

    let branchProjectArray = Array.from(
      { length: ageGenderFields.branchProject.length },
      (v, i) => ageGenderFields.branchProject[i]
    );
    let branchProjectResult = branchProjectArray.join(",");

    let sdpArray = Array.from(
      { length: ageGenderFields.sdp.length },
      (v, i) => ageGenderFields.sdp[i]
    );
    let sdpResult = sdpArray.join(",");

    let areaArray = Array.from(
      { length: ageGenderFields.area.length },
      (v, i) => ageGenderFields.area[i]
    );
    let areaResult = areaArray.join(",");

    let serviceCategoryArray = Array.from(
      { length: ageGenderFields.serviceCategory.length },
      (v, i) => ageGenderFields.serviceCategory[i]
    );
    let serviceCategoryResult = serviceCategoryArray.join(",");

    let serviceSubCategoryArray = Array.from(
      { length: ageGenderFields.serviceSubCategory.length },
      (v, i) => ageGenderFields.serviceSubCategory[i]
    );
    let serviceSubCategoryResult = serviceSubCategoryArray.join(",");

    let servicesArray = Array.from(
      { length: ageGenderFields.servicesName.length },
      (v, i) => ageGenderFields.servicesName[i]
    );
    let servicesResult = servicesArray.join(",");

    if (
      !branchProjectValidate &&
      !sdpValidate &&
      !areaValidate &&
      !serviceCategoryValidate &&
      !serviceSubCategoryValidate &&
      !servicesNameValidate
    ) {
      const ReportData = [
        {
          mstBranchId: branchProjectResult,
          mstSDPId: sdpResult,
          mstAreaId: areaResult,
          mstServicesCategoryId: serviceCategoryResult,
          mstServicesSubCategoryId: serviceSubCategoryResult,
          mstServicesId: servicesResult,
          fromDate: fromDate,
          toDate: toDate,
          mstProjectId: project ? project : null,
        },
      ];
      const response = await BindPostAPI(
        ReportData,
        "TXNServicesAPI/ReportAgeGenderDonorSRH"
      );
      setBindAgeGenderDonorSRH(response.data.Table);
      setShowTable(true);
    } else {
    }
  };
  // const handleExport = () => {
  //   const dateRange = {
  //     fromDate: fromDate,
  //     toDate: toDate,
  //   };

  //   const selectedOptionsData = {
  //     branchProjectData:
  //       branchProjectNamesList.length > 0
  //         ? branchProjectNamesList.toString()
  //         : branchName,
  //     sdpData: sdpNamesList.toString(),
  //     areaData: areaNamesList.toString(),
  //     serviceCategoryData: serviceCategoryNameList.toString(),
  //     serviceSubCategoryData: serviceSubCategoryNameList.toString(),
  //     servicesData: serviceNameList.toString(),
  //   };
  //   exportData(
  //     ageGenderDonorSRHHeader.map((column) => column.title),
  //     bindAgeGenderDonorSRH,
  //     dateRange,
  //     selectedOptionsData
  //   );
  // };


  const createdBy = sessionStorage.getItem("createdBy");

  const handleExport = async () => {
    try {
      const dateRange = {
        fromDate: fromDate,
        toDate: toDate,
      };

      const selectedOptionsData = {
        branchProjectData:
          branchProjectNamesList.length > 0
            ? branchProjectNamesList.toString()
            : branchName,
        sdpData: sdpNamesList.toString(),
        areaData: areaNamesList.toString(),
        serviceCategoryData:
          serviceCategoryNameList.toString(),
        serviceSubCategoryData:
          serviceSubCategoryNameList.toString(),
        servicesData:
          serviceNameList.toString(),
      };

      // Export Function
      await exportData(
        ageGenderDonorSRHHeader.map(
          (column) => column.title
        ),
        bindAgeGenderDonorSRH,
        dateRange,
        selectedOptionsData
      );

      // ✅ Success Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `Age Gender Donor SRH Report`,
          action: "Excel Export",
          status: "SUCCESS",
          tableName: null,
          description: `Age Gender Donor SRH Report Excel exported successfully, From ${fromDate} to ${toDate}`,
        },
        "Log/IUDLog"
      );

      console.log(
        "Age Gender Donor SRH Report Excel export completed successfully"
      );
    } catch (error) {
      console.error(
        "Age Gender Donor SRH Report Excel export failed:",
        error
      );

      // ❌ Failed Log
      await IUDAPI(
        {
          mstUserId: parseInt(createdBy, 10),
          sp: `Age Gender Donor SRH Report`,
          action: "Excel Export",
          status: "FAILED",
          tableName: null,
          description: `Age Gender Donor SRH Report Excel export failed - ${error?.message || "Unknown Error"
            }`,
        },
        "Log/IUDLog"
      );
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    return `${date.getDate().toString().padStart(2, "0")}-${(
      date.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${date.getFullYear()}`;
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      const NameList = ageGenderFields.branchProject
        .map(
          (option) =>
            bindBranchProjectDD?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setBranchProjectNamesList(NameList);
    }

    if (ageGenderFields.sdp) {
      const NameList = ageGenderFields.sdp
        .map((option) => bindSDP?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setSDPNamesList(NameList);
    }

    if (ageGenderFields.area) {
      const NameList = ageGenderFields.area
        .map((option) => bindArea?.find((item) => item.value === option)?.label)
        .filter(Boolean); // Remove undefined values if any
      setAreaNamesList(NameList);
    }

    if (ageGenderFields.serviceCategory) {
      const NameList = ageGenderFields.serviceCategory
        .map(
          (option) =>
            bindServiceCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceCategoryNameList(NameList);
    }

    if (ageGenderFields.serviceSubCategory) {
      const NameList = ageGenderFields.serviceSubCategory
        .map(
          (option) =>
            bindServiceSubCategory?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceSubCategoryNameList(NameList);
    }

    if (ageGenderFields.servicesName) {
      const NameList = ageGenderFields.servicesName
        .map(
          (option) =>
            bindServicesName?.find((item) => item.value === option)?.label
        )
        .filter(Boolean); // Remove undefined values if any
      setServiceNameList(NameList);
    }
  }, [ageGenderFields]);

  const exportData = (columns, rows, dateRange, selectedDetails) => {
    // ============================================================
    // 1. FIXED AGE/GENDER COLUMN ORDER
    // ============================================================
    // IMPORTANT:
    // Never use Object.entries(rowData) for these columns.
    // Always use this fixed order.
    const ageGenderColumns = [
      {
        key: "FemaleAge0to9",
        label: "0-9 yrs Female",
      },
      {
        key: "MaleAge0to9",
        label: "0-9 yrs Male",
      },
      {
        key: "OtherAge0to9",
        label: "0-9 yrs Others",
      },

      {
        key: "FemaleAge10to14",
        label: "10-14 Yrs Female",
      },
      {
        key: "MaleAge10to14",
        label: "10-14 Yrs Male",
      },
      {
        key: "OtherAge10to14",
        label: "10-14 Yrs Others",
      },

      {
        key: "FemaleAge15to18",
        label: "15-18 Yrs Female",
      },
      {
        key: "MaleAge15to18",
        label: "15-18 Yrs Male",
      },
      {
        key: "OtherAge15to18",
        label: "15-18 Yrs Others",
      },

      {
        key: "FemaleAge19",
        label: "19 Yrs Female",
      },
      {
        key: "MaleAge19",
        label: "19 Yrs Male",
      },
      {
        key: "OtherAge19",
        label: "19 Yrs Others",
      },

      {
        key: "FemaleAge20to24",
        label: "20-24 Yrs Female",
      },
      {
        key: "MaleAge20to24",
        label: "20-24 Yrs Male",
      },
      {
        key: "OtherAge20to24",
        label: "20-24 Yrs Others",
      },

      {
        key: "FemaleAge25to29",
        label: "25-29 Yrs Female",
      },
      {
        key: "MaleAge25to29",
        label: "25-29 Yrs Male",
      },
      {
        key: "OtherAge25to29",
        label: "25-29 Yrs Others",
      },

      {
        key: "FemaleAge30to34",
        label: "30-34 Yrs Female",
      },
      {
        key: "MaleAge30to34",
        label: "30-34 Yrs Male",
      },
      {
        key: "OtherAge30to34",
        label: "30-34 Yrs Others",
      },

      {
        key: "FemaleAge35to39",
        label: "35-39 Yrs Female",
      },
      {
        key: "MaleAge35to39",
        label: "35-39 Yrs Male",
      },
      {
        key: "OtherAge35to39",
        label: "35-39 Yrs Others",
      },

      {
        key: "FemaleAge40to44",
        label: "40-44 Yrs Female",
      },
      {
        key: "MaleAge40to44",
        label: "40-44 Yrs Male",
      },
      {
        key: "OtherAge40to44",
        label: "40-44 Yrs Others",
      },

      {
        key: "FemaleAge45to49",
        label: "45-49 Yrs Female",
      },
      {
        key: "MaleAge45to49",
        label: "45-49 Yrs Male",
      },
      {
        key: "OtherAge45to49",
        label: "45-49 Yrs Others",
      },

      {
        key: "FemaleAge50to59",
        label: "50-59 Yrs Female",
      },
      {
        key: "MaleAge50to59",
        label: "50-59 Yrs Male",
      },
      {
        key: "OtherAge50to59",
        label: "50-59 Yrs Others",
      },

      {
        key: "FemaleAge60andAbove",
        label: "60 Yrs and Above Female",
      },
      {
        key: "MaleAge60andAbove",
        label: "60 Yrs and Above Male",
      },
      {
        key: "OtherAge60andAbove",
        label: "60 Yrs and Above Others",
      },
    ];

    // ============================================================
    // 2. TITLE ROW
    // ============================================================
    const titleRow = [
      {
        v: "Age&Gender Donor - SRH",
        s: {
          font: {
            bold: true,
            sz: 16,
          },
          alignment: {
            horizontal: "left",
          },
        },
      },
    ];

    // ============================================================
    // 3. DATE RANGE ROW
    // ============================================================
    const dateRangeRow = [
      { v: "" },

      {
        v: "From Date:",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: formatDate(dateRange.fromDate),
        s: {
          alignment: {
            horizontal: "left",
          },
        },
      },

      {
        v: "To Date:",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "left",
          },
        },
      },

      {
        v: formatDate(dateRange.toDate),
        s: {
          alignment: {
            horizontal: "left",
          },
        },
      },
    ];

    // ============================================================
    // 4. BRANCH / SDP / AREA ROW
    // ============================================================
    const branchRow = [
      { v: "" },

      {
        v: "Branch/Project:",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: selectedDetails.branchProjectData || "",
        s: {
          alignment: {
            horizontal: "left",
            wrapText: true,
          },
        },
      },

      {
        v: "S.D.P.:",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: selectedDetails.sdpData || "",
        s: {
          alignment: {
            horizontal: "left",
            wrapText: true,
          },
        },
      },

      {
        v: "Area:",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: selectedDetails.areaData || "",
        s: {
          alignment: {
            horizontal: "left",
            wrapText: true,
          },
        },
      },
    ];

    // ============================================================
    // 5. SERVICES INFORMATION ROW
    // ============================================================
    const servicesRow = [
      { v: "" },

      {
        v: "Service Category",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: selectedDetails.serviceCategoryData || "",
        s: {
          alignment: {
            horizontal: "left",
            wrapText: true,
          },
        },
      },

      {
        v: "Service Sub-Category",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: selectedDetails.serviceSubCategoryData || "",
        s: {
          alignment: {
            horizontal: "left",
            wrapText: true,
          },
        },
      },

      {
        v: "Services",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            horizontal: "right",
          },
        },
      },

      {
        v: selectedDetails.servicesData || "",
        s: {
          alignment: {
            horizontal: "left",
            wrapText: true,
          },
        },
      },
    ];

    // ============================================================
    // 6. SPACING ROW
    // ============================================================
    const spacingRow = [{ v: "" }];

    // ============================================================
    // 7. HEADER ROW
    // ============================================================
    const headerStyle = {
      fill: {
        fgColor: {
          rgb: "2D2D6E",
        },
      },
      font: {
        bold: true,
        color: {
          rgb: "FFFFFF",
        },
      },
      alignment: {
        horizontal: "center",
        vertical: "center",
        wrapText: true,
      },
    };

    const headerRow = [
      // First 6 columns
      ...columns.slice(0, 6).map((column) => ({
        v: column,
        s: headerStyle,
      })),

      // Fixed age/gender columns
      ...ageGenderColumns.map(({ label }) => ({
        v: label,
        s: headerStyle,
      })),

      // Total
      {
        v: "Total",
        s: headerStyle,
      },
    ];

    // ============================================================
    // 8. INITIALIZE COLUMN TOTALS
    // ============================================================
    const columnTotals = {};

    ageGenderColumns.forEach(({ key }) => {
      columnTotals[key] = 0;
    });

    // ============================================================
    // 9. DATA ROWS
    // ============================================================
    const dataRows = rows.map((rowData, index) => {
      const isAlternateRow = index % 2 === 1;

      const baseStyle = isAlternateRow
        ? {
          fill: {
            fgColor: {
              rgb: "F0F0F0",
            },
          },
        }
        : {};

      // ----------------------------------------------------------
      // Calculate row total
      // ----------------------------------------------------------
      let rowTotal = 0;

      ageGenderColumns.forEach(({ key }) => {
        const value = Number(rowData[key] || 0);

        rowTotal += value;

        // Column total
        columnTotals[key] += value;
      });

      // ----------------------------------------------------------
      // Fixed first 6 columns
      // ----------------------------------------------------------
      const formattedRow = [
        {
          v: index + 1,
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "left",
            },
          },
        },

        {
          v: rowData.Branch || "",
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "left",
            },
          },
        },

        {
          v: rowData.SDP_en || "",
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "left",
            },
          },
        },

        {
          v: rowData.AreaName_en || "",
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "left",
            },
          },
        },

        {
          v: rowData.Services_en || "",
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "left",
            },
          },
        },

        {
          v: rowData.ProjectName_en || "",
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "left",
            },
          },
        },

        // --------------------------------------------------------
        // AGE/GENDER VALUES
        // --------------------------------------------------------
        // IMPORTANT:
        // This uses the exact same order as headerRow.
        // Therefore Female/Male/Other can never shift.
        // --------------------------------------------------------
        ...ageGenderColumns.map(({ key }) => ({
          v: Number(rowData[key] || 0),
          t: "n",
          s: {
            ...baseStyle,
            alignment: {
              horizontal: "right",
            },
            numFmt: "0",
          },
        })),

        // --------------------------------------------------------
        // ROW TOTAL
        // --------------------------------------------------------
        {
          v: rowTotal,
          t: "n",
          s: {
            ...baseStyle,
            font: {
              bold: true,
            },
            alignment: {
              horizontal: "right",
            },
            numFmt: "0",
          },
        },
      ];

      return formattedRow;
    });

    // ============================================================
    // 10. TOTAL ROW STYLE
    // ============================================================
    const totalsRowStyle = {
      font: {
        bold: true,
      },
      fill: {
        fgColor: {
          rgb: "E0E0E0",
        },
      },
      alignment: {
        horizontal: "left",
        vertical: "center",
      },
    };

    // ============================================================
    // 11. TOTAL ROW
    // ============================================================
    const grandTotal = ageGenderColumns.reduce(
      (sum, { key }) => sum + columnTotals[key],
      0
    );

    const totalsRow = [
      {
        v: "",
        s: totalsRowStyle,
      },

      {
        v: "",
        s: totalsRowStyle,
      },

      {
        v: "",
        s: totalsRowStyle,
      },

      {
        v: "",
        s: totalsRowStyle,
      },

      {
        v: "",
        s: totalsRowStyle,
      },

      {
        v: "Total",
        s: totalsRowStyle,
      },

      // ----------------------------------------------------------
      // AGE/GENDER TOTALS
      // Same exact order as header and data
      // ----------------------------------------------------------
      ...ageGenderColumns.map(({ key }) => ({
        v: columnTotals[key],
        t: "n",
        s: {
          ...totalsRowStyle,
          alignment: {
            horizontal: "right",
          },
          numFmt: "0",
        },
      })),

      // ----------------------------------------------------------
      // GRAND TOTAL
      // ----------------------------------------------------------
      {
        v: grandTotal,
        t: "n",
        s: {
          ...totalsRowStyle,
          alignment: {
            horizontal: "right",
          },
          numFmt: "0",
        },
      },
    ];

    // ============================================================
    // 12. COMBINE ALL ROWS
    // ============================================================
    const wsData = [
      titleRow,
      dateRangeRow,
      branchRow,
      servicesRow,
      spacingRow,
      headerRow,
      ...dataRows,
      totalsRow,
    ];

    // ============================================================
    // 13. CREATE WORKSHEET
    // ============================================================
    const ws = XLSX.utils.aoa_to_sheet(wsData);

    // ============================================================
    // 14. COLUMN WIDTHS
    // ============================================================
    const totalColumns = 6 + ageGenderColumns.length + 1;

    ws["!cols"] = Array.from(
      { length: totalColumns },
      (_, index) => {
        // First columns
        if (index === 0) {
          return { width: 10 };
        }

        if (index >= 1 && index <= 5) {
          return { width: 30 };
        }

        // Age/Gender columns
        if (
          index >= 6 &&
          index < 6 + ageGenderColumns.length
        ) {
          return { width: 16 };
        }

        // Total column
        return { width: 15 };
      }
    );

    // ============================================================
    // 15. ROW HEIGHTS
    // ============================================================
    ws["!rows"] = [
      { hpt: 30 }, // Title
      { hpt: 20 }, // Date range
      { hpt: 30 }, // Branch / SDP / Area
      { hpt: 45 }, // Services
      { hpt: 15 }, // Spacing
      { hpt: 35 }, // Header

      // Data rows
      ...Array(rows.length).fill({ hpt: 20 }),

      // Total row
      { hpt: 25 },
    ];

    // ============================================================
    // 16. APPLY BORDERS
    // ============================================================
    const applyStyles = (worksheet) => {
      const range = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let R = range.s.r; R <= range.e.r; R++) {
        for (let C = range.s.c; C <= range.e.c; C++) {
          const cellRef = XLSX.utils.encode_cell({
            r: R,
            c: C,
          });

          if (!worksheet[cellRef]) {
            continue;
          }

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,

            border: {
              top: {
                style: "thin",
                color: {
                  rgb: "000000",
                },
              },

              bottom: {
                style: "thin",
                color: {
                  rgb: "000000",
                },
              },

              left: {
                style: "thin",
                color: {
                  rgb: "000000",
                },
              },

              right: {
                style: "thin",
                color: {
                  rgb: "000000",
                },
              },
            },
          };
        }
      }
    };

    applyStyles(ws);

    // ============================================================
    // 17. CREATE WORKBOOK
    // ============================================================
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Sheet1"
    );

    // ============================================================
    // 18. EXPORT EXCEL
    // ============================================================
    XLSX.writeFile(
      wb,
      "Age&Gender - Donor-SRH.xlsx"
    );
  };

  const downloadPDF = () => {
    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: "a3",
    });
    const logoWidth = 30;
    const logoHeight = 14;
    doc.addImage(fpaiLogo, "JPEG", 10, 10, logoWidth, logoHeight);

    const headers = ageGenderDonorSRHHeader.map((column) => column.title);

    const data = bindAgeGenderDonorSRH.map((rowData, index) => {
      return [
        index + 1,
        rowData.Branch,
        rowData.Services_en,
        rowData.FemaleAge0to9,
        rowData.MaleAge0to9,
        rowData.OtherAge0to9,
        rowData.FemaleAge10to14,
        rowData.MaleAge10to14,
        rowData.OtherAge10to14,
        rowData.FemaleAge15to18,
        rowData.MaleAge15to18,
        rowData.OtherAge15to18,
        rowData.FemaleAge19,
        rowData.MaleAge19,
        rowData.OtherAge19,
        rowData.FemaleAge20to24,
        rowData.MaleAge20to24,
        rowData.OtherAge20to24,
        rowData.FemaleAge25to29,
        rowData.MaleAge25to29,
        rowData.OtherAge25to29,
        rowData.FemaleAge30to34,
        rowData.MaleAge30to34,
        rowData.OtherAge30to34,
        rowData.FemaleAge35to39,
        rowData.MaleAge35to39,
        rowData.OtherAge35to39,
        rowData.FemaleAge40to44,
        rowData.MaleAge40to44,
        rowData.OtherAge40to44,
        rowData.FemaleAge45to49,
        rowData.MaleAge45to49,
        rowData.OtherAge45to49,
        rowData.FemaleAge50to59,
        rowData.MaleAge50to59,
        rowData.OtherAge50to59,
        rowData.FemaleAge60AndAbove,
        rowData.MaleAge60AndAbove,
        rowData.OtherAge60AndAbove,
      ];
    });

    // Create the table with headers and data
    doc.autoTable({
      head: [headers],
      body: data,
      startY: 30,
      styles: {
        fontSize: 7, // Reduced font size
        lineColor: "black",
        lineWidth: 0.2,
        halign: "center", // Align text to center
        valign: "middle", // Align text vertically in the middle
        cellPadding: 2, // Add padding to cells
        overflow: "linebreak", // Allow text to wrap within cells
      },
      headStyles: {
        fillColor: "#2d2d6e",
        textColor: [255, 255, 255],
      },
      alternateRowStyles: {
        fillColor: [240, 240, 240], // Light gray color for alternate rows
      },
      columnStyles: {
        0: { cellWidth: 10 }, // Index column
        1: { cellWidth: "auto" }, // Auto adjust width
        2: { cellWidth: "auto" }, // Auto adjust width
        3: { cellWidth: "auto" }, // Auto adjust width
        4: { cellWidth: "auto" }, // Auto adjust width
        5: { cellWidth: "auto" }, // Auto adjust width
        6: { cellWidth: "auto" }, // Auto adjust width
        7: { cellWidth: "auto" }, // Auto adjust width
        8: { cellWidth: "auto" }, // Auto adjust width
        9: { cellWidth: "auto" }, // Auto adjust width
        10: { cellWidth: "auto" }, // Age
        11: { cellWidth: "auto" }, // Gender
        12: { cellWidth: "auto" }, // Auto adjust width
        13: { cellWidth: "auto" }, // Auto adjust width
        14: { cellWidth: "auto" }, // Auto adjust width
        15: { cellWidth: "auto" }, // Auto adjust width
        16: { cellWidth: "auto" }, // Index column
        17: { cellWidth: "auto" }, // Auto adjust width
        18: { cellWidth: "auto" }, // Auto adjust width
        19: { cellWidth: "auto" }, // Auto adjust width
        20: { cellWidth: "auto" }, // Auto adjust width
        21: { cellWidth: "auto" }, // Auto adjust width
        22: { cellWidth: "auto" }, // Auto adjust width
        23: { cellWidth: "auto" }, // Auto adjust width
        24: { cellWidth: "auto" }, // Auto adjust width
        25: { cellWidth: "auto" }, // Auto adjust width
        26: { cellWidth: "auto" }, // Age
        27: { cellWidth: "auto" }, // Gender
        28: { cellWidth: "auto" }, // Auto adjust width
        29: { cellWidth: "auto" }, // Auto adjust width
        30: { cellWidth: "auto" }, // Auto adjust width
        31: { cellWidth: "auto" }, // Auto adjust width
        32: { cellWidth: "auto" }, // Auto adjust width
        33: { cellWidth: "auto" }, // Auto adjust width
        34: { cellWidth: "auto" }, // Age
        35: { cellWidth: "auto" }, // Gender
        36: { cellWidth: "auto" }, // Auto adjust width
        37: { cellWidth: "auto" }, // Auto adjust width
        38: { cellWidth: "auto" }, // Auto adjust width
        39: { cellWidth: "auto" }, // Auto adjust width
        40: { cellWidth: "auto" }, // Auto adjust width
      },
    });

    doc.save("Age&Gender - Donor-SRH.pdf");
  };
  const BranchProjectFetchData = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const locationResponse = await BindPostAPI([data], "LocationAPI/BindLocation");

      const locationData = locationResponse.data.Table.map((item) => ({
        value: item.MstLocationId,
        label: item.LocationName_en,
      }));

      setBindBranchProjectDD(locationData);
    } catch (error) { }
  };

  useEffect(() => {
    const getSelectedServiceSubCategory = async () => {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };

      const serviceSubCategoryResponse = await BindPostAPI([data],
        "ServicesSubCategoryAPI/BindServicesSubCategory"
      );
      setGetServiceSubCDatas(serviceSubCategoryResponse.data.Table);
    };
    // Bind service Dropdown datas
    const getSelectedServices = async () => {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const serviceSubCategoryResponse = await BindPostAPI([data],
        "ServicesMasterAPI/BindServices"
      );
      setGetServicesDatas(serviceSubCategoryResponse.data.Table);
    };

    getSelectedServices();

    getSelectedServiceSubCategory();
  }, []);

  const serviceCategoryDD = async () => {
    try {
      const userProfileDatas = userProfileState.userProfile;
      const [profile] = userProfileDatas;
      const data = {
        mstOrganizationStructureId: profile.MstOrganizationId,
        mstBranchId: profile.MstLocationId,
        mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
        mstUserId: profile.MstUserId,
        mstRoleId: profile.MstRoleId,
        languageCode: "en",
      };
      const serviceCategoryResponse = await BindPostAPI([data],
        "ServicesCategoryAPI/BindServicesCategory"
      );

      const serviceCategoryData = serviceCategoryResponse.data.Table.map(
        (item) => ({
          value: item.MstServicesCategoryId,
          label: item.ServicesCategory_en,
        })
      );

      setBindServiceCategory(serviceCategoryData);
    } catch (error) {
      // Handle API call errors (e.g., show an error message)
    }
  };
  useEffect(() => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const automaticFromDate = `${currentYear}-01-01`;
    setFromDate(automaticFromDate);

    const formattedToDate = today.toISOString().split("T")[0];
    setToDate(formattedToDate);
  }, []);

  const ageGenderFieldsChange = (value, name) => {
    setShowTable(false);
    setAgeGenderFields({
      ...ageGenderFields,
      [name]: value,
    });
  };

  useEffect(() => {
    if (ageGenderFields.branchProject) {
      try {
        const getSelectedSDP = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };

          const locationResponse = await BindPostAPI([data], "SDPAPI/GetSDP");
          setGetSDPDatas(locationResponse.data.Table);

          if (userProfileDatas && userProfileDatas[0]) {
            const sdpLabels = locationResponse.data.Table.filter((item) =>
              ageGenderFields.branchProject.includes(
                parseInt(item.MstLocationId)
              )
            ).map((item) => ({
              MstSDPId: item.MstSDPId,
              SDP_en: item.SDP_en,
            }));

            const sdpSelected = sdpLabels.map((SD) => ({
              value: SD.MstSDPId,
              label: SD.SDP_en,
            }));

            if (
              userProfileDatas[0].MstOrganizationId == 1 ||
              userProfileDatas[0].MstOrganizationId == 2
            ) {
              setBindSDP(sdpSelected);
            } else {
              const allSDPIds = userProfileDatas[0]?.AllSDP;
              const sdpId = userProfileDatas[0]?.MstSDPId;
              if (allSDPIds && Array.isArray(allSDPIds)) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  allSDPIds.includes(sdp.value)
                );
                setBindSDP(filteredSdpSelected);
              }
              if (sdpId) {
                const filteredSdpSelected = sdpSelected.filter((sdp) =>
                  Array.isArray(sdpId)
                    ? sdpId.includes(sdp.value)
                    : sdpId === sdp.value
                );

                setBindSDP(filteredSdpSelected);
              }
            }
          }
        };

        getSelectedSDP();
      } catch (e) { }
    }
  }, [
    ageGenderFields.branchProject ? ageGenderFields.branchProject : undefined,
    userProfileDatas ? userProfileDatas : undefined,
  ]);

  useEffect(() => {
    if (ageGenderFields.sdp) {
      try {
        const getSelectedArea = async () => {
          const userProfileDatas = userProfileState.userProfile;
          const [profile] = userProfileDatas;
          const data = {
            mstOrganizationStructureId: profile.MstOrganizationId,
            mstBranchId: profile.MstLocationId,
            mstSdpId: profile.MstSDPId ?? 0, // nullish coalescing, safer than ternary
            mstUserId: profile.MstUserId,
            mstRoleId: profile.MstRoleId,
            languageCode: "en",
          };

          const locationResponse = await BindPostAPI([data], "AreaAPI/GetArea");
          setGetAreaDatas(locationResponse.data.Table);

          const areaLabels = locationResponse.data.Table.filter((item) =>
            ageGenderFields.sdp.includes(item.MstSDPId)
          ).map((item) => ({
            MstAreaId: item.MstAreaId,
            AreaName_en: item.AreaName_en,
          }));

          const areaSelected = areaLabels.map((AR) => ({
            value: AR.MstAreaId,
            label: AR.AreaName_en,
          }));

          setBindAreaDD(areaSelected);
        };

        getSelectedArea();
      } catch (e) { }
    }
  }, [ageGenderFields.sdp ? ageGenderFields.sdp : undefined]);

  useEffect(() => {
    // Bind Services Sub Category Dropdown datas

    const serviceSubCategorySelectedValue = ageGenderFields.serviceCategory;
    setBindServiceSubCategory([]);
    if (serviceSubCategorySelectedValue) {
      const serviceSubCategoryLabels = getServiceSubCDatas
        .filter((item) =>
          serviceSubCategorySelectedValue.includes(item.MstServicesCategoryId)
        )
        .map((item) => ({
          MstServicesSubCategoryId: item.MstServicesSubCategoryId,
          ServicesSubCategory_en: item.ServicesSubCategory_en,
        }));

      const servicesSubCategorySelected = serviceSubCategoryLabels.map(
        (AR) => ({
          value: AR.MstServicesSubCategoryId,
          label: AR.ServicesSubCategory_en,
        })
      );
      setBindServiceSubCategory(servicesSubCategorySelected);
    } else {
    }
  }, [ageGenderFields.serviceCategory]);

  useEffect(() => {
    // Bind Services Dropdown datas

    const selectedSubCategories = ageGenderFields.serviceSubCategory;
    setBindServicesName([]);
    if (selectedSubCategories.length > 0) {
      const servicesLabels = getServicesData
        .filter((item) =>
          selectedSubCategories.includes(item.MstServicesSubCategoryId)
        )
        .map((item) => ({
          MstServicesId: item.MstServicesId,
          Services_en: item.Services_en,
        }));

      const servicessSelected = servicesLabels.map((AR) => ({
        value: AR.MstServicesId,
        label: AR.Services_en,
      }));
      setBindServicesName(servicessSelected);
    } else {
      // Handle the case when no sub-categories are selected
      setBindServicesName([]);
    }
  }, [ageGenderFields.serviceSubCategory]);

  return (
    <MainLayout pageName="4">
      <div>
        <div class="relative m-3 bg-white rounded-lg ">
          <div class="mt-3 py-4">
            <div className={mainTable.headerTitle}>
              <div className="my-2 mx-12 lg:mx-0">{`Age&Gender - Donor-SRH`}</div>
            </div>
            <div className={mainTable.grid3}>
              {userProfileDatas[0]?.MstOrganizationId == 1 && (
                <div>
                  <MultiSelect
                    classStar="text-red-500"
                    label="Branch/Project"
                    filteredOptions={bindBranchProjectDD}
                    classFilterLabel="p-1 flex gap-1"
                    class="custom-class"
                    placeholder={
                      ageGenderFields.branchProject?.length > 0
                        ? "More Selected"
                        : "Select..."
                    }
                    name="branchProject"
                    selectedOptions={ageGenderFields.branchProject}
                    classDiv="relative w-full inline-block"
                    onChange={(e) => {
                      ageGenderFieldsChange(e, "branchProject");
                    }}
                    classLabel={mainTable.labelNoWrap}
                  />
                  {ageGenderFieldsError.branchProjectError && (
                    <span className="text-red-500">
                      {ageGenderFieldsError.branchProjectError}
                    </span>
                  )}
                </div>
              )}
              {(userProfileDatas[0]?.MstOrganizationId == 2 ||
                userProfileDatas[0]?.MstOrganizationId == 3) && (
                  <InputText
                    inputType="text"
                    title="Branch/Project"
                    classStar="text-red-500"
                    name="branchName"
                    disabled="true"
                    content={branchName}
                    controlFunc={(e) => setBranchName(e.target.value)}
                  />
                )}
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="SDP"
                  filteredOptions={bindSDP}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.sdp?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="sdp"
                  selectedOptions={ageGenderFields.sdp}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "sdp");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.sdpError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.sdpError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Area"
                  filteredOptions={bindArea}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.area?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="area"
                  selectedOptions={ageGenderFields.area}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "area");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.areaError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.areaError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Category"
                  filteredOptions={bindServiceCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceCategory"
                  selectedOptions={ageGenderFields.serviceCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "serviceCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Service Sub-Category"
                  filteredOptions={bindServiceSubCategory}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.serviceSubCategory?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="serviceSubCategory"
                  selectedOptions={ageGenderFields.serviceSubCategory}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "serviceSubCategory");
                  }}
                  classLabel={mainTable.labelNoWrap}
                />
                {ageGenderFieldsError.serviceSubCategoryError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.serviceSubCategoryError}
                  </span>
                )}
              </div>
              <div>
                <MultiSelect
                  classStar="text-red-500"
                  label="Services"
                  filteredOptions={bindServicesName}
                  classFilterLabel="p-1 flex gap-1"
                  class="custom-class"
                  placeholder={
                    ageGenderFields.servicesName?.length > 0
                      ? "More Selected"
                      : "Select..."
                  }
                  name="servicesName"
                  selectedOptions={ageGenderFields.servicesName}
                  classDiv="relative w-full inline-block"
                  onChange={(e) => {
                    ageGenderFieldsChange(e, "servicesName");
                  }}
                />
                {ageGenderFieldsError.servicesNameError && (
                  <span className="text-red-500">
                    {ageGenderFieldsError.servicesNameError}
                  </span>
                )}
              </div>
              <AutoDropDown
                title="Project"
                options={bindProjectDD}
                placeholder="Select"
                name="project"
                selectedOption={bindProjectDD.find((x) => x.value == project)}
                Class="custom-class"
                tabIndex="1"
                controlFunc={(value, e) => {
                  setProject(value.value);
                }}
              />
            </div>
            <div class={mainTable.grid3}>
              <InputText
                inputType="date"
                title="From"
                name="fromDate"
                content={fromDate}
                controlFunc={(e) => {
                  setFromDate(e.target.value);
                  setShowTable(false);
                }}
              />
              <InputText
                inputType="date"
                title="To"
                name="toDate"
                content={toDate}
                controlFunc={(e) => {
                  setToDate(e.target.value);
                  setShowTable(false);
                }}
              />
              <div class="flex justify-start items-center mt-6">
                <button
                  type="button"
                  onClick={() => GoButton()}
                  className={mainTable.addButton}
                >
                  GO
                </button>
              </div>
            </div>
          </div>
        </div>
        {showTable &&
          (bindAgeGenderDonorSRH.length > 0 ? (
            <div className=" ">
              <ReportGridPage
                title=""
                header={ageGenderDonorSRHHeader}
                records={bindAgeGenderDonorSRH}
                handleExport={handleExport}
                handlePDF={downloadPDF}
              />
            </div>
          ) : (
            <div className="flex items-center justify-center">
              No record found
            </div>
          ))}
      </div>
    </MainLayout>
  );
};

export default ReportAgeGenderDonorSRH;
